import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SignatureSizeMtoComponent } from './signature-size-mto/signature-size-mto.component';
import { SignatureSizeMtoRoutingModule } from './signature-size-mto-routing.module';

@NgModule({
  declarations: [SignatureSizeMtoComponent],
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    SignatureSizeMtoRoutingModule,
    SharedModule
  ]
})
export class SignatureSizeMtoModule { }
